import { useState, useEffect } from 'react';

interface Config {
  widgetAutoRefreshIntervalMs: number;
}

export function useConfig() {
  const [config, setConfig] = useState<Config | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    const fetchConfig = async () => {
      try {
        setLoading(true);
        const response = await fetch('/api/config');
        if (!response.ok) {
          throw new Error(`Failed to fetch config: ${response.status} ${response.statusText}`);
        }
        const data = await response.json() as Config;
        setConfig(data);
        setError(null);
      } catch (err) {
        const error = err instanceof Error ? err : new Error('Failed to fetch config');
        setError(error);
        // Set default on error
        setConfig({ widgetAutoRefreshIntervalMs: 120000 });
      } finally {
        setLoading(false);
      }
    };

    fetchConfig();
  }, []);

  return {
    config,
    loading,
    error,
    widgetAutoRefreshIntervalMs: config?.widgetAutoRefreshIntervalMs ?? 120000
  };
}



